export default __webpack_public_path__ + "static/media/Telkari of the Judgment Bolt.50cbc916.jpg";